<p-dialog
  header="Confirm approval"
  [closable]="!submitting()"
  [modal]="true"
  [style]="{ width: '32rem' }"
  [visible]="visible()"
  (visibleChange)="onVisibleChange($event)"
>
  <p class="confirm-text">
    Approve
    <strong>{{ entreeName() }}</strong>
    ?
  </p>
  @if (warning()) {
    <p-message severity="warn" styleClass="approve-warning" [text]="warning()!"></p-message>
  }
  <p class="helper-text">The Healthy Gourmet Kitchen will be notified that this menu item is approved.</p>

  <ng-template pTemplate="footer">
    <p-button
      label="Cancel"
      severity="secondary"
      [disabled]="submitting()"
      [text]="true"
      (onClick)="onCancel()"
    ></p-button>
    <p-button
      icon="pi pi-check"
      label="Approve"
      severity="primary"
      [loading]="submitting()"
      (onClick)="onApprove()"
    ></p-button>
  </ng-template>
</p-dialog>
